import _ from "underscore";
import DutyStatusLog from "../model/DutyStatusLog";
import { getCurrentVehicle } from "../utils/device";

function getUniqueDevicesFromLogs(logs): any[] {
    let currentVehicle = getCurrentVehicle();
    let returnDeviceIds: any[] = [];

    if (logs.length) {
        returnDeviceIds = _.uniq(logs.map((log) => {
            if (log instanceof DutyStatusLog) {
                return log.getDeviceId();
            } else if (log && log.device) {
                if (log.device === "NoDeviceId") {
                    return log.device;
                } else {
                    return log && log.device.id;
                }
            }
        }));
    } else if (currentVehicle) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        returnDeviceIds.push[currentVehicle.id];
    }

    return returnDeviceIds;
}

export {
    getUniqueDevicesFromLogs
};
